module.exports = __webpack_public_path__ + "media/day/122-c4ba85f5.svg";